import { render, staticRenderFns } from "./AccommodationFeatures.vue?vue&type=template&id=537fa462&scoped=true&"
import script from "./AccommodationFeatures.vue?vue&type=script&lang=ts&"
export * from "./AccommodationFeatures.vue?vue&type=script&lang=ts&"
import style0 from "./AccommodationFeatures.vue?vue&type=style&index=0&id=537fa462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537fa462",
  null
  
)

export default component.exports